import {
  HStack,
  Link,
  type StackProps,
  Text,
  VStack,
} from '@ayble-health/dashboard-components';
import { Box } from '@chakra-ui/react';
import { Loader } from '../../Loader';

type CardProps = StackProps & {
  loading?: boolean;
  title: string;
  icon?: React.ReactElement;
  text?: string | number | null;
  bottomTag: { text: string; onClick?: () => void; icon?: React.ReactElement };
};

export const OverviewCard = ({
  loading,
  title,
  text,
  bottomTag,
  icon,
  ...props
}: CardProps) => {
  return (
    <VStack
      rounded={'lg'}
      p={4}
      borderWidth={1}
      align={'flex-start'}
      gap={0}
      {...props}
    >
      <HStack
        align={'start'}
        w={'100%'}
        h={8}
        gap={6}
        justifyContent={'space-between'}
      >
        <Text
          color={'seafoam'}
          fontSize={'xs'}
          fontWeight={'medium'}
          textTransform={'uppercase'}
        >
          {title}
        </Text>

        {icon}
      </HStack>

      {loading ? (
        <Loader loading />
      ) : (
        <>
          <Text
            color={'secondary.500'}
            fontFamily={'heading'}
            fontSize={'2xl'}
            fontWeight={'normal'}
          >
            {text}
          </Text>
          {!!bottomTag.onClick ? (
            <Link
              fontSize={'sm'}
              color={'bluegrey'}
              variant={'plain'}
              w={'100%'}
              onClick={bottomTag.onClick}
            >
              {bottomTag.text}
              <Box ml={'auto'}>{bottomTag.icon}</Box>
            </Link>
          ) : (
            <HStack w={'100%'} align={'center'}>
              <Text
                fontSize={'sm'}
                fontWeight={'normal'}
                color={'bluegrey'}
                w={'100%'}
              >
                {bottomTag.text}
              </Text>
              <Box>{bottomTag.icon}</Box>
            </HStack>
          )}
        </>
      )}
    </VStack>
  );
};

export default OverviewCard;
